import React from "react";
import { tabLabels } from "./constant";

const Tabs = ({ activeTabName, activeTabID, onClickTab, openMod }) => {
  const { FULFILMENT, MARKETING, SALES, OPERATIONS } = tabLabels;

  const renderTabTitle = (tabTitle, isActive, id) => (
    <div
      onClick={() => onClickTab(id)}
      // id={id}
      className={`tab-item ${isActive && "tab-border"}`}
    >
      <p className={`tab-ite ${isActive && "activetabText"}`}>{tabTitle}</p>
    </div>
  );

  return (
    <>
      <section>
        <div className="container">
          <div className="row justify-content-center">
            <p className="bigPhs" style={{ textAlign: "center" }}>
              Automation plugs for all your needs
            </p>
            <div className="text-center tabs">
              {renderTabTitle(
                FULFILMENT,
                // activeTabName === FULFILMENT,
                activeTabID === 0,
                0
              )}
              {renderTabTitle(
                MARKETING,
                // activeTabName === MARKETING,
                activeTabID === 1,
                1
              )}
              {renderTabTitle(
                SALES,
                // activeTabName === SALES,
                activeTabID === 2,
                2
              )}
              {renderTabTitle(
                OPERATIONS,
                // activeTabName === OPERATIONS,
                activeTabID === 3,
                3
              )}
            </div>
            <div className="tabContent text-center">
              {activeTabID === 0 && (
                <div id="tab-1-content">
                  <h6 className="tabtext">
                    Experience a streamlined fulfilment process with the help of
                    our fulfilment plugs and focus on growing your business with
                    PlugIt.Our platform allows you to automate every step, from
                    collecting order information to communicating with customers
                    and tracking deliveries. Say goodbye to the stress of
                    managing multiple fulfilment partners and communicating with
                    customers.
                  </h6>
                  <img
                    alt="fulfilment"
                    className="tabImage"
                    src="fulfilment.svg"
                  />
                  <img
                    alt="fulfilment"
                    className="tabImageMobile"
                    src="fulfilmentMobile.svg"
                  />
                  <button onClick={openMod} className="butn butn-primary ">
                     Let's streamline your fulfilment process
                  </button>
                </div>
              )}
              {activeTabID === 1 && (
                <div id="tab-2-content">
                  {" "}
                  <h6 className="tabtext">
                    Say goodbye to repetitive entries and constant app-hopping -
                    PlugIt automates the entire process for you. Save time and
                    resources by automating messaging across SMS, email, and
                    push notifications. Give yourself and your team the freedom
                    to focus on creativity and growing your business with
                    PlugIt.
                  </h6>
                  <img
                    alt="marketing"
                    className="tabImage"
                    src="marketing.svg"
                  />
                  <img
                    alt="marketing"
                    className="tabImageMobile"
                    src="marketingMobile.svg"
                  />
                  <button onClick={openMod} className="butn butn-primary ">
                     Let's streamline your marketing efforts
                  </button>
                </div>
              )}
              {activeTabID === 2 && (
                <div id="tab-3-content">
                  {" "}
                  <h6 className="tabtext">
                    Our platform allows you to automate your follow-up and
                    lead-generation process through our plugs. Effectively
                    convert leads into paying customers by pacing out
                    communications at the right intervals. With minimal changes,
                    you can streamline your sales process and see an increase in
                    conversions with PlugIt.
                  </h6>
                  <img alt="sales" className="tabImage" src="sales.svg" />
                  <img
                    alt="sales"
                    className="tabImageMobile"
                    src="salesMobile.svg"
                  />
                  <button onClick={openMod} className="butn butn-primary ">
                    Let's simplify sales
                  </button>
                </div>
              )}
              {activeTabID === 3 && (
                <div id="tab-4-content">
                  {" "}
                  <h6 className="tabtext">
                    Our platform allows you to automate repetitive tasks like
                    inventory management and reordering, saving you valuable
                    time and resources. Centralize all operations through
                    automation with PlugIt and enjoy the benefits of increased
                    efficiency and improved brand goodwill.
                  </h6>
                  <img
                    alt="operations"
                    className="tabImage"
                    src="operations.svg"
                  />
                  <img
                    alt="operations"
                    className="tabImageMobile"
                    src="operationsMobile.svg"
                  />
                  <button onClick={openMod} className="butn butn-primary ">
                     Let's simplify sales
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Tabs;
